import classNames from 'classnames/bind';
import React from 'react';

import styles from './index.module.scss';

import EmptyList from '@/components/ui/EmptyList';

const cx = classNames.bind(styles);

const Empty = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('header')}>
        <div className={cx('title')}>Commands</div>
      </div>
      <div className={cx('body')}>
        <div className={cx('empty')}>
          <EmptyList message="No mission loaded" />
        </div>
      </div>
    </div>
  );
};

export default Empty;
